/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mantine/core";
import dayjs from "dayjs";
import { FiFileText, FiAlertCircle, FiRefreshCw, FiInfo } from "react-icons/fi";
import { STATUS_COLORS, normalizeStatus } from "./status";
import AtkPasqyratFinanciare from "./AtkPasqyratFinanciare";

const NGJYRA_KRYESORE = "#1c4fb8";
const TEKSTI_I_ZBEHTE = "#6b7280";

const stiliKutise = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "4rem 2rem",
    background: "#f8faff",
    borderRadius: 12,
    border: "1.5px dashed #c7d4f0",
    gap: 12,
    textAlign: "center",
};

const stiliIkonesSeMadhe = {
    width: 52,
    height: 52,
    borderRadius: "50%",
    background: "#e8eef8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: NGJYRA_KRYESORE,
    flexShrink: 0,
};

const kaVlere = (v) => v !== null && v !== undefined && String(v).trim() !== "";

// Nje rresht th/td, si ne tabin ARBK. Rreshtat pa vlere nuk shfaqen fare.
const Rreshti = ({ etiketa, vlera, lloji, info }) => {
    if (!kaVlere(vlera)) return null;

    const teksti = String(vlera).trim();
    let permbajtja = teksti;

    if (lloji === "email") {
        permbajtja = (
            <a href={"mailto:" + teksti} style={{ color: NGJYRA_KRYESORE, wordBreak: "break-all" }}>
                {teksti}
            </a>
        );
    } else if (lloji === "telefon") {
        permbajtja = (
            <a href={"tel:" + teksti.replace(/\s+/g, "")} style={{ color: NGJYRA_KRYESORE }}>
                {teksti}
            </a>
        );
    } else if (lloji === "status") {
        // Statusi vjen me fjalorin e ATK-se (AKTIV/PASIV), prandaj teksti mbetet ashtu
        // si eshte dhe vetem ngjyra merret nga harta e perbashket e statuseve.
        const ngjyra = STATUS_COLORS[normalizeStatus(teksti)];
        permbajtja = (
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "3px 10px",
                    borderRadius: 999,
                    border: "1px solid " + ngjyra + "59",
                    background: ngjyra + "1f",
                    color: ngjyra,
                    fontSize: 13,
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                }}
            >
                <span
                    style={{ width: 8, height: 8, borderRadius: "50%", background: ngjyra, flexShrink: 0 }}
                    aria-hidden
                />
                {teksti}
            </span>
        );
    }

    return (
        <tr>
            <th>
                {info ? (
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                        {etiketa}
                        {/* withinPortal: tooltip-i del jashte tabeles, qe te mos e presin kufijte e qelizes. */}
                        <Tooltip label={info} withArrow multiline width={260} position="top" withinPortal>
                            {/* Buton (jo span me tabIndex): keshtu tooltip-i hapet edhe me tastiere
                                dhe s'e shkel rregullin jsx-a11y/no-noninteractive-tabindex. */}
                            <button
                                type="button"
                                aria-label={info}
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 0,
                                    background: "none",
                                    border: "none",
                                    color: NGJYRA_KRYESORE,
                                    cursor: "help",
                                    flexShrink: 0,
                                    lineHeight: 0,
                                }}
                            >
                                <FiInfo size={15} />
                            </button>
                        </Tooltip>
                    </span>
                ) : (
                    etiketa
                )}
            </th>
            <td>{permbajtja}</td>
        </tr>
    );
};

Rreshti.propTypes = {
    etiketa: PropTypes.string.isRequired,
    vlera: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lloji: PropTypes.string,
    info: PropTypes.string,
};

// Tatimpaguesi e ka mohuar pelqimin per kete bllok: serveri s'dergon asnje fushe,
// prandaj ne vend te tabeles shfaqet ky njoftim.
const NjoftimiPaPelqim = ({ mesazhi }) => (
    <div
        style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 10,
            padding: "14px 16px",
            background: "#fff8e6",
            border: "1px solid #f0d9a8",
            borderRadius: 4,
            color: "#8a6d1f",
            fontSize: 14,
            lineHeight: 1.5,
        }}
    >
        <FiInfo size={17} style={{ marginTop: 2, flexShrink: 0 }} />
        <span>{mesazhi}</span>
    </div>
);

NjoftimiPaPelqim.propTypes = {
    mesazhi: PropTypes.string.isRequired,
};

// Nje seksion = titull + tabele (ose njoftim), e njejta strukture qe perdor tabi ARBK
// (.content-details + .table-details). Kthen null kur s'ka as rreshta as njoftim.
const Seksioni = ({ titulli, njoftimi, children }) => {
    const rreshtat = React.Children.toArray(children).filter(Boolean);
    if (rreshtat.length === 0 && !njoftimi) return null;

    return (
        <div className="content-details">
            <h4>{titulli}</h4>
            {njoftimi ? (
                <NjoftimiPaPelqim mesazhi={njoftimi} />
            ) : (
                <div className="table-details" style={{ marginTop: 0 }}>
                    <table>
                        <tbody>{rreshtat}</tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

Seksioni.propTypes = {
    titulli: PropTypes.string.isRequired,
    njoftimi: PropTypes.string,
    children: PropTypes.node,
};

const AtkPanel = ({ teDhenat, token, dukeNgarkuar, gabimi, onRiprovo, L }) => {
    if (dukeNgarkuar) {
        return (
            <div style={stiliKutise}>
                <span style={stiliIkonesSeMadhe}>
                    <FiFileText size={24} />
                </span>
                <p style={{ margin: 0, color: TEKSTI_I_ZBEHTE, fontSize: 15 }}>{L.loading}</p>
            </div>
        );
    }

    // Gabim rrjeti/sherbimi: perdoruesi mund te riprovoje pa e rifreskuar faqen.
    // "s'ka te dhena" (404) nuk eshte gabim — bie ne gjendjen bosh me poshte.
    if (gabimi) {
        return (
            <div style={stiliKutise}>
                <span style={{ ...stiliIkonesSeMadhe, background: "#fdecea", color: "#c0392b" }}>
                    <FiAlertCircle size={24} />
                </span>
                <p style={{ margin: 0, color: TEKSTI_I_ZBEHTE, fontSize: 15 }}>{L.error}</p>
                <button
                    type="button"
                    onClick={onRiprovo}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        padding: "8px 16px",
                        background: NGJYRA_KRYESORE,
                        color: "#fff",
                        border: "none",
                        borderRadius: 999,
                        fontWeight: 600,
                        fontSize: 13,
                        cursor: "pointer",
                    }}
                >
                    <FiRefreshCw size={13} />
                    {L.retry}
                </button>
            </div>
        );
    }

    if (!teDhenat) {
        return (
            <div style={stiliKutise}>
                <span style={stiliIkonesSeMadhe}>
                    <FiFileText size={24} />
                </span>
                <p style={{ margin: 0, color: TEKSTI_I_ZBEHTE, fontSize: 15 }}>{L.empty}</p>
            </div>
        );
    }

    const adresa = teDhenat.Adresa;
    const kontabilisti = teDhenat.Kontabilisti;
    const llogaria = teDhenat.LlogariaBankare;
    const adresaPaPelqim = teDhenat.AdresaPaPelqim;
    const kontabilistiPaPelqim = teDhenat.KontabilistiPaPelqim;
    const llogariaPaPelqim = teDhenat.LlogariaBankarePaPelqim;
    const punetoret = Number(teDhenat.NumriPunetoreve);
    const kaPunetore = teDhenat.NumriPunetoreve !== null && teDhenat.NumriPunetoreve !== undefined && Number.isFinite(punetoret);
    // I njejti format si "Data e regjistrimit" ne tabin ARBK.
    const dataStatusit = teDhenat.DataStatusit && dayjs(teDhenat.DataStatusit).isValid()
        ? dayjs(teDhenat.DataStatusit).format("DD/MM/YYYY")
        : null;

    // Komuna, vendi, rruga dhe kodi postar shkojne ne nje rresht te vetem "Adresa";
    // pjeset qe ATK-ja i kthen bosh thjesht bien jashte.
    const adresaTeksti = adresa
        ? [adresa.Komuna, adresa.Vendi, adresa.Rruga, adresa.KodiPostar]
            .filter(kaVlere)
            .map((p) => String(p).trim())
            .join(", ")
        : "";

    // I njejti ritem si tabi ARBK: 50px mes seksioneve, 30px mes titullit dhe tabeles.
    return (
        <div style={{ display: "grid", gap: 50, minWidth: 0 }}>
            <Seksioni titulli={L.tatimpaguesi}>
                <Rreshti etiketa={L.nui} vlera={teDhenat.NumriFiskal} />
                <Rreshti etiketa={L.emri} vlera={teDhenat.Emri} />
                <Rreshti
                    etiketa={L.numriPunetoreve}
                    vlera={kaPunetore ? punetoret : null}
                    info={L.numriPunetorevePershkrim}
                />
                <Rreshti etiketa={L.statusi} vlera={teDhenat.Statusi} lloji="status" />
                <Rreshti etiketa={L.dataStatusit} vlera={dataStatusit} />
            </Seksioni>

            {/* Blloku vjen null nga serveri kur s'ka pelqim; flamuri *PaPelqim tregon
                nese arsyeja eshte mohimi i pelqimit apo thjesht mungesa e te dhenave. */}
            {adresa ? (
                <Seksioni titulli={L.adresaTitulli}>
                    <Rreshti etiketa={L.adresa} vlera={adresaTeksti} />
                    <Rreshti etiketa={L.telefoni} vlera={adresa.Telefoni} lloji="telefon" />
                    <Rreshti etiketa={L.email} vlera={adresa.Email} lloji="email" />
                </Seksioni>
            ) : adresaPaPelqim ? (
                <Seksioni titulli={L.adresaTitulli} njoftimi={L.paPelqim} />
            ) : null}

            {kontabilisti ? (
                <Seksioni titulli={L.kontabilisti}>
                    <Rreshti etiketa={L.emriKontabilistit} vlera={kontabilisti.Emri} />
                    <Rreshti etiketa={L.telefoni} vlera={kontabilisti.Telefoni} lloji="telefon" />
                    <Rreshti etiketa={L.email} vlera={kontabilisti.Email} lloji="email" />
                </Seksioni>
            ) : kontabilistiPaPelqim ? (
                <Seksioni titulli={L.kontabilisti} njoftimi={L.paPelqim} />
            ) : null}

            {llogaria ? (
                <Seksioni titulli={L.llogariaBankare}>
                    <Rreshti etiketa={L.banka} vlera={llogaria.Banka} />
                    <Rreshti etiketa={L.numriLlogarise} vlera={llogaria.NumriLlogarise} />
                </Seksioni>
            ) : llogariaPaPelqim ? (
                <Seksioni titulli={L.llogariaBankare} njoftimi={L.paPelqim} />
            ) : null}

            {/* key: biznes tjeter => zgjedhja dhe skedari i meparshem nuk mbeten. */}
            {token ? <AtkPasqyratFinanciare key={token} token={token} L={L} /> : null}

            <p style={{ margin: 0, fontSize: 12.5, color: TEKSTI_I_ZBEHTE }}>{L.burimi}</p>
        </div>
    );
};

AtkPanel.propTypes = {
    teDhenat: PropTypes.object,
    token: PropTypes.string,
    dukeNgarkuar: PropTypes.bool,
    gabimi: PropTypes.bool,
    onRiprovo: PropTypes.func,
    L: PropTypes.object.isRequired,
};

export default AtkPanel;
